import { useMutation } from "../../utils/error-handling/apollo-hooks-wrappers/custom-apollo-hooks";
import { UpdateLastSelectedDataSourcesDocument, UpdateUserPersonaDocument, } from '../generated/graphql-types';
export const useUpdateLastSelectedDataSources = () => {
    const [updateLastSelectedDataSources, { data, error, loading },] = useMutation(UpdateLastSelectedDataSourcesDocument);
    return {
        data,
        error,
        loading,
        updateLastSelectedDataSources: (ids) => updateLastSelectedDataSources({ variables: { ids } }),
    };
};
export const useUpdateUserPersona = () => {
    const [updateUserPersona, { data, error, loading }] = useMutation(UpdateUserPersonaDocument);
    return {
        data: data?.User__updateUserPersona,
        error,
        loading,
        updateUserPersona: (userpersona) => updateUserPersona({
            variables: {
                userpersona,
            },
        }),
    };
};
//# sourceMappingURL=user-admin-service.js.map